import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'
import 'buefy/lib/buefy.css'

import 'es6-promise/auto'
import card from 'card'
import VeeValidate, { Validator } from'vee-validate'

Vue.use(Buefy);


new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js